import {
    useContext,
    useState,
    useRef
} from "react";
import {
    Image,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    NCoreUIKitToast,
    PageContainer,
    TextInput,
    Button,
    Text
} from "ncore-ui-kit";
import {
    useNavigation
} from "@react-navigation/native";
import type RootStackParamList from "../../navigation/type";
import type {
    NativeStackNavigationProp
} from "@react-navigation/native-stack";
import md5 from "md5";
import {
    AuthContext
} from "../../contexts/AuthContext";
import RESTServiceContext from "../../services/restAPI/context";
import logo from "../../assets/images/logo.png";

const Login = () => {
    const [
        identifier,
        setIdentifier
    ] = useState("");

    const [
        password,
        setPassword
    ] = useState("");

    const [
        isSubmitting,
        setIsSubmitting
    ] = useState(false);

    const passwordRef = useRef<import("ncore-ui-kit").ITextInputRef>(null);

    const {
        login
    } = useContext(AuthContext);

    const {
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

    const handleLogin = async () => {
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        try {
            const data = await RESTServiceContext.action("adminLogin", {
                password: md5(password),
                mail: identifier
            });

            if (data.code === 200 || data.code === 201) {
                const userInfo = data.payload?.userInfo;
                await login(data.payload?.accessToken || "", {
                    ...(userInfo as Record<string, unknown>),
                    role: userInfo?.adminType || "admin"
                } as Parameters<typeof login>[1], data.payload?.refreshToken);
            }
        } catch (error: unknown) {
            const err = error as Error;
            NCoreUIKitToast.open({
                title: err?.message || localize("login-toast-network-error"),
                type: "danger"
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return <PageContainer
        scrollViewStyle={{
            backgroundColor: colors.project.inputBackground
        }}
        scrollViewProps={{
            contentContainerStyle: [
                stylesheet.scrollContentContainer,
                {
                    paddingBottom: spaces.spacingXl * 3
                }
            ],
            showsHorizontalScrollIndicator: false,
            showsVerticalScrollIndicator: false
        }}
        isCustomPadding={true}
        isScrollable={true}
    >
        <View
            style={[
                stylesheet.container,
                {
                    padding: spaces.spacingXl
                }
            ]}
        >
            <Image
                style={[
                    stylesheet.logo,
                    {
                        marginBottom: spaces.spacingXl
                    }
                ]}
                resizeMode="contain"
                source={logo}
            />
            <Text
                variant="titleLargeSize"
            >
                {localize("login-page-title")}
            </Text>
            <Text
                style={{
                    marginBottom: spaces.spacingXl,
                    marginTop: spaces.spacingMd
                }}
                variant="bodyLargeSize"
            >
                {localize("login-page-subtitle")}
            </Text>
            <View
                style={stylesheet.formContainer}
            >
                <TextInput
                    onSubmitEditing={() => passwordRef.current?.focus?.()}
                    placeholder={localize("login-identifier-placeholder")}
                    customColor={colors.project.brandWhite}
                    keyboardType="email-address"
                    onChangeText={setIdentifier}
                    spreadBehaviour="stretch"
                    autoCapitalize="none"
                    returnKeyType="next"
                    value={identifier}
                />
                <View
                    style={{
                        height: spaces.spacingMd
                    }}
                />
                <TextInput
                    placeholder={localize("login-password-placeholder")}
                    customColor={colors.project.brandWhite}
                    onSubmitEditing={handleLogin}
                    onChangeText={setPassword}
                    spreadBehaviour="stretch"
                    returnKeyType="done"
                    ref={passwordRef}
                    variant="hidden"
                    value={password}
                />
                <View
                    style={{
                        height: spaces.spacingLg
                    }}
                />
                <Button
                    title={localize("login-submit-button")}
                    spreadBehaviour="stretch"
                    isLoading={isSubmitting}
                    onPress={handleLogin}
                />
                <View
                    style={[
                        stylesheet.forgotPasswordContainer,
                        {
                            marginTop: spaces.spacingMd
                        }
                    ]}
                >
                    <Button
                        onPress={() => navigation.navigate("ForgotPassword")}
                        title={localize("login-forgot-password-button")}
                        spreadBehaviour="stretch"
                        variant="ghost"
                    />
                </View>
                {/*  <View
                    style={[
                        stylesheet.guestButtonContainer,
                        {
                            marginTop: spaces.spacingSm
                        }
                    ]}
                >
                    <Button
                        title={localize("login-guest-button")}
                        spreadBehaviour="stretch"
                        onPress={guestLogin}
                        variant="outline"
                    />
                </View> */}
            </View>
        </View>
    </PageContainer>;
};
export default Login;
